const delimiter = '-';
function getSkuStringNumber(sku) {
  if (!sku) {
    return null;
  }
  const startNumberPosition = sku.indexOf(delimiter);
  const endNumberPosition = sku.lastIndexOf(delimiter);
  const samePosition = startNumberPosition === endNumberPosition;

  if (startNumberPosition < endNumberPosition) {
    const tempString = sku.substring(startNumberPosition + 1, endNumberPosition);
    return tempString;
  }

  if (samePosition && startNumberPosition === 2) {
    return sku.substring(startNumberPosition + 1);
  }

  if (samePosition && startNumberPosition > 2) {
    const tempString = sku.substring(0, startNumberPosition);

    return tempString.match(/\d+/).join();
  }
  return null;
}

function getSkuStringSuffix(sku) {
  if (!sku) {
    return null;
  }

  const startNumberPosition = sku.indexOf(delimiter);
  const endNumberPosition = sku.lastIndexOf(delimiter);
  const samePosition = startNumberPosition === endNumberPosition;

  if (startNumberPosition && endNumberPosition && startNumberPosition < endNumberPosition) {
    return sku.substring(endNumberPosition + 1);
  }

  if (samePosition && startNumberPosition > 2) {
    return sku.substring(endNumberPosition + 1);
  }

  return null;
}

function getGroupNumber(groupedLineItems, itemSkuNumber) {
  const lineItemsGroup = groupedLineItems.find(li => li.itemNumber === itemSkuNumber);
  if (lineItemsGroup) {
    return itemSkuNumber;
  }
  const groupItem = groupedLineItems.find(f => f.lineItems.find(li => li.sku === itemSkuNumber));
  if (groupItem) {
    return groupItem.itemNumber;
  }
  return null;
}

function parseSku(sku) {
  return {
    number: getSkuStringNumber(sku),
    suffix: getSkuStringSuffix(sku),
  };
}

export { parseSku, getGroupNumber };
